var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { forwardRef } from "react";
import { Tab } from "./Tab";
import { TabsList } from "./TabsList";
import { useTabs } from "./TabsManager";
/**
 * The `Tabs` component is used to render all the configured `tabs` from the
 * parent `TabsManager` component inside of the `TabsList`.
 */
export var Tabs = forwardRef(function Tabs(props, ref) {
    var _a = useTabs(), tabsId = _a.tabsId, tabs = _a.tabs, activeIndex = _a.activeIndex, onActiveIndexChange = _a.onActiveIndexChange;
    return (_jsx(TabsList, __assign({}, props, { id: tabsId, ref: ref, activeIndex: activeIndex, onActiveIndexChange: onActiveIndexChange }, { children: tabs.map(function (_a, index) {
            var id = _a.id, config = __rest(_a, ["id"]);
            return (_createElement(Tab, __assign({}, config, { id: id, key: id, active: activeIndex === index })));
        }) }), void 0));
});
//# sourceMappingURL=Tabs.js.map